// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router'
import { useStore } from 'vuex';

import HomePage from '@/views/HomePage.vue'
import AboutPage from '@/views/AboutPage.vue'
import AgentSignUp from '@/views/AgentSignUp.vue'
import AgentLanding from '@/views/AgentLanding.vue'
import SignUp from '@/views/SignUp.vue'
import ListingDetails from '@/views/dashboardViews/ListingDetails.vue'
import DealsPage from '@/views/DealsPage.vue'
import ContactUs from '@/views/ContactUs.vue'

import DealDetail from '@/views/DealDetail.vue'
import BookCruise from '@/views/BookCruise.vue'

import AdminDashboard from '@/views/AdminDashboard.vue';
import HomeView from '@/views/dashboardViews/homeView.vue';
import UserHomeView from '@/views/dashboardViews/UserHomeView.vue'
import MyProfile from '@/views/dashboardViews/MyProfile.vue';
import NewListing from '@/views/dashboardViews/NewListing.vue';
import CurrentListings from '@/views/dashboardViews/CurrentListings.vue';
import PendingAgents from '@/views/dashboardViews/PendingAgents.vue';
import PendingAgentViewer from '@/views/dashboardViews/PendingAgentViewer.vue';
import AdminListingDetails from '@/views/dashboardViews/AdminListingDetails.vue'
import Messages from '@/views/dashboardViews/Messages.vue'
import EmailTemplates from '@/views/dashboardViews/EmailTemplates.vue'
//import BookingStep2 from '@/views/BookingStep2.vue'
import BookingCheckout from '@/views/BookingCheckout.vue'
import ManageBookingClient from '@/views/ManageBookingClient.vue';
import Agents from '@/views/dashboardViews/Agents.vue';
import AgentDetail from '@/views/dashboardViews/AgentDetail.vue';
import NotificationsView from '@/views/dashboardViews/NotificationsView.vue';
import AfterSignup from '@/views/AfterSignup.vue';

import BookingCabin from '@/views/BookingCabin.vue';
import BookingPreferences from '@/views/BookingPreferences.vue';
import BookingGuestInfo from '@/views/BookingGuestInfo.vue';

import UserBookings from '@/views/clientDashboardViews/UserBookings.vue';
import UserWishlist from '@/views/clientDashboardViews/UserWishlist.vue';
import ProfileView from '@/views/clientDashboardViews/ProfileView.vue';

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/about', name: 'About', component: AboutPage },
  { path: '/deals', name: 'Deals', component: DealsPage },

  //{ path: '/deals/listing/:id', name: 'DealDetail', component: DealDetail, meta: { requiresAuth: true } },
  { path: '/deals/listing/:id', name: 'DealDetail', component: DealDetail },
  { path: '/deals/listing/:id/select-cabin', name: 'SelectCabin', component: BookingCabin },
  { path: '/deals/listing/:id/:listing/preferences', name: 'Preferences', component: BookingPreferences },
  { path: '/deals/listing/:id/:listing/guest-info', name: 'GuestInfo', component: BookingGuestInfo },
  { path: '/deals/listing/:id/:listing/checkout', name: 'CheckOut', component: BookingCheckout },

  { path: '/booking/:id', name: 'BookCruise', component: BookCruise },
  { path: '/contact', name: 'Contact', component: ContactUs },
  { path: '/agent/signup', name: 'Agent Sign Up', component: AgentSignUp },
  { path: '/agent/signup/done', name: 'Agent Sign Up Complete', component: AfterSignup },
  { path: '/login', name: 'Sign Up', component: SignUp },
  { path: '/agent', name: 'Partner With Us', component: AgentLanding },
  {
    path: '/dashboard',
    component: AdminDashboard,
    children: [
      { path: '', redirect: 'home' },
      { path: 'home', component: HomeView },
      { path: 'bookings', component: UserHomeView },
      { path: 'bookings/:id', component: ManageBookingClient },
      { path: 'profile', component: MyProfile },
      { path: 'post-listing', component: NewListing },
      { path: 'listings', component: CurrentListings },
      { path: 'pending-agents', component: PendingAgents },
      { path: 'pending-agents/:uid', component: PendingAgentViewer },
      { path: 'listings/:id', component: ListingDetails },
      { path: 'listings/admin/:id', component: AdminListingDetails },
      { path: 'messages', component: Messages },
      { path: 'notifications', component: NotificationsView },
      { path: 'email-templates', component: EmailTemplates },
      { path: 'agents', component: Agents },
      { path: 'agents/:uid', component: AgentDetail },
    ]
  },
  { path: '/account/bookings', name: 'My Bookings', component: UserBookings },
  { path: '/account/wishlist', name: 'My Wishlist', component: UserWishlist },
  { path: '/account/profile', name: 'My Profile', component: ProfileView },


]


const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 })
})

router.beforeEach((to) => {
  // Manually scroll to top on route change
  window.scrollTo(0, 0);

  if (!to.meta.requiresAuth)
    return true

  const store = useStore();

  if (store.state.user)
    return true

  return { name: 'Home', query: { redirect: to.fullPath } }
});


export default router;
